import { gsap } from "gsap";
import GspAnimate from "../modules/GspAnimate";
const gspAnimate= new GspAnimate();

class SectionLandingReviews {
    init(){
        this.cardReviewTwo=document.querySelectorAll('.card-review-two');
        gspAnimate.StagerAnimation(this.cardReviewTwo)
    } 
}
export default SectionLandingReviews